<template>
  <div id="contenedor-eliminar-contratista">
      <v-card>
          <v-card-title class="secondary--text">
              Eliminar Contratista
          </v-card-title>
          <v-card-text>
            <span>
              {{ `¿Desea eliminar al contratista ${ contratistaEliminar.nombreRazonSocial }?`}}
            </span>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarContratista"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import mixCatalogoContratistas from './mixCatalogoContratistas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarContratista',
  mixins: [mixCatalogoContratistas],
  props: {
    contratistaEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
